var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 12C36 15.9 32.9 19 29 19H9C5.1 19 2 15.9 2 12C2 8.1 5.1 5 9 5H29C32.9 5 36 8.1 36 12Z",
    fill: "#00A68B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_121_4445)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 22C33.5228 22 38 17.5228 38 12C38 6.47715 33.5228 2 28 2C22.4772 2 18 6.47715 18 12C18 17.5228 22.4772 22 28 22Z",
    fill: "#00A68B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7594 12C37.7594 17.39 33.39 21.7594 28 21.7594C22.61 21.7594 18.2406 17.39 18.2406 12C18.2406 6.61002 22.61 2.24058 28 2.24058C33.39 2.24058 37.7594 6.61002 37.7594 12Z",
    stroke: "url(#paint0_linear_121_4445)",
    strokeWidth: 0.481164
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7594 12C37.7594 17.39 33.39 21.7594 28 21.7594C22.61 21.7594 18.2406 17.39 18.2406 12C18.2406 6.61002 22.61 2.24058 28 2.24058C33.39 2.24058 37.7594 6.61002 37.7594 12Z",
    stroke: "url(#paint1_linear_121_4445)",
    strokeWidth: 0.481164
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_121_4445",
    x: 16.0753,
    y: 1.03767,
    width: 23.8493,
    height: 23.8493,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.962328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.962328
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_4445"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0962328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.144349
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_121_4445",
    result: "effect2_dropShadow_121_4445"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_121_4445",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_4445",
    x1: 18.0979,
    y1: 2,
    x2: 18.0979,
    y2: 21.8043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_4445",
    x1: 18,
    y1: 2,
    x2: 18,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/toggle-on.6d36302e.svg";
export { ForwardRef as ReactComponent };